import { PLAYER } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#27272A] bg-[#09090B]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 grid place-items-center bg-[#FF007F] text-white font-display text-xl">
              {PLAYER.jersey}
            </div>
            <div>
              <div className="font-display uppercase tracking-wider text-lg">
                {PLAYER.name}
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">
                Believe &amp; Give • {PLAYER.team} #{PLAYER.jersey}
              </div>
            </div>
          </div>
          <p className="text-[#71717A] text-sm mt-6 max-w-md">
            A focused fundraiser to send Camden and the Wookies to the 7th Annual Native
            American Junior Nationals — Mesa, AZ, June 25–28, 2026.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#71717A] mb-3">
            Navigate
          </div>
          <ul className="space-y-2 text-[#D4D4D8]">
            <li><a href="#donate" className="link-reveal hover:text-white">Donate</a></li>
            <li><a href="#story" className="link-reveal hover:text-white">Story</a></li>
            <li><a href="#gallery" className="link-reveal hover:text-white">Gallery</a></li>
            <li><a href="#donors" className="link-reveal hover:text-white">Donors</a></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#71717A] mb-3">
            Disclaimer
          </div>
          <p className="text-[#71717A] text-xs leading-relaxed">
            Donations are personal gifts and not tax-deductible. Payments are processed
            securely via Stripe.
          </p>
        </div>
      </div>
      <div className="border-t border-[#27272A] py-5 text-center text-[10px] uppercase tracking-[0.3em] text-[#52525B]">
        © {new Date().getFullYear()} {PLAYER.name} • Believe loud, work louder.
      </div>
    </footer>
  );
}
